import { apiClient } from "@/lib/api-client";

export type GiftOption = {
  participants: Array<{
    name: string;
    amount?: number | null;
    note?: string | null;
    createdAt: string;
  }>;
  id: string;
  slug: string;
  title: string;
  description?: string | null;
  kind: string;
  suggestedAmount?: number | null;
  currency: string;
  imageUrl?: string | null;
  isActive: boolean;
  contributionCount: number;
  totalAmount: number;
};

export type PaginatedResponse<T> = {
  items: T[];
  meta: {
    total: number;
    limit: number;
    offset: number;
  };
};

export type GiftSelectionPayload = {
  giftOptionId: string;
  name: string;
  amount?: number;
  message?: string;
};

export type GiftSelectionResponse = {
  message: string;
  referenceId: string;
};

export async function fetchGiftOptions(
  params: { limit?: number; offset?: number } = {},
): Promise<PaginatedResponse<GiftOption>> {
  const searchParams = new URLSearchParams();
  if (typeof params.limit === "number") {
    searchParams.set("limit", String(params.limit));
  }
  if (typeof params.offset === "number") {
    searchParams.set("offset", String(params.offset));
  }

  const suffix = searchParams.toString() ? `?${searchParams.toString()}` : "";
  return apiClient.get<PaginatedResponse<GiftOption>>(`/gifts${suffix}`);
}

export async function submitGiftSelection(
  payload: GiftSelectionPayload,
): Promise<GiftSelectionResponse> {
  return apiClient.post<GiftSelectionResponse>("/gifts", payload);
}
